export default __webpack_public_path__ + "static/media/polygon-matic-logo.6cde40a9.png";